import React, { useState, useEffect, useMemo } from 'react';
import { Modal, ModalBody, ModalHeader, Input, FormGroup, Button, Label, Form } from 'reactstrap';
import { useNavigate,useLocation } from 'react-router-dom';
import { exportToCSV, exportToExcel, exportToPDF } from '../utils/Exports';
import moment from 'moment';
import $ from 'jquery';
import { parseValue } from '../utils/Common';
import Table from './common/Table';


const common = require('../utils/Common');
const envConfig = require('../config/envConfig');

export default function SellerLogisticsOrders() {
    const navigate = useNavigate();
    const [orders, setOrders] = useState([]);
    const [deliveryUsers, setDeliveryUsers] = useState([]);
    const [orderImagesData, setOrderImagesData] = useState([]);
    const [showOrderImagesModal, setShowOrderImagesModal] = useState(false);
    const location = useLocation();
    const [totalRecords, setTotalRecords] = useState(0);
    

    useEffect(() => {
        getOrders();
        getDeliveryUsers();
    }, []);

    const getOrders = async (limit = 10, offset = 0, search = {}) => {
        let data = {
            'seller_id': location.state.sellerId,
            'start_date':location.state.startDate.length > 0 ? location.state.startDate : $('#Date-from').val(),
            'end_date': location.state.endDate.length > 0 ? location.state.endDate : $('#Date-to').val(),
            'logistics': 1,
            "source": "admin",
            'limit': limit,
            'offset': offset
        }
        let response = await common.apiRequest('post', '/seller/get-orders', data);
        if (response.data.code === 'success') {
            setOrders(response.data.data);
            setTotalRecords(response.data.totalRecords);
        } else {
            setOrders([]);
        }
    }

    const getDeliveryUsers = async () => {
        let data = {
            'action': 'read',
            'deliver_manager_id': location.state
        }
        let response = await common.apiRequest('post', '/delivery/crud-delivery-users', data);
        if (response.data.code === 'success') {
            setDeliveryUsers(response.data.data);
        } else {
            setDeliveryUsers([]);
        }
    }

    const generateInvoice = async (sellerId, orderId, invoiceType) => {
        let response = await common.getInvoiceData([sellerId], orderId, invoiceType);
        if (response.length === 0) {
            alert('No invoice');
            return;
        }
        navigate(
            '/generate-invoice',
            {
                state: {
                    invoiceData: response
                }
            }
        )
    }

    const generateCommissionInvoice = async (orderId) => {
        let response = await common.getCommissionInvoice(orderId, 'logistics');
        if (response.length === 0) {
            common.alert('No invoice', 'error');
            return;
        }
        navigate(
            '/generate-commission-invoice',
            {
                state: {
                    invoiceData: response
                }
            }
        );
    }

    const generateReturnReplaceCancelInvoice = async (orderId, sellerIds, type, invoiceType) => {
        let response = await common.getInvoiceData(sellerIds, orderId, type, 1);
        navigate(
            '/generate-return-invoice',
            {
                state: {
                    invoiceData: response,
                    invoiceType: invoiceType
                }
            }
        )
    }

    const showOrderImages = async (orderItemId) => {
        let response = await common.fetchOrderImages(orderItemId);
        if (response && response.data && response.data.data && response.data.data.length > 0) {
            setOrderImagesData(response.data.data);
            setShowOrderImagesModal(true);
        } else {
            setOrderImagesData([]);
            setShowOrderImagesModal(false);
            alert("No Order Images Found", "info");
        }
    }

    const data = orders.map(data => ({
        order_type: data.type?.toUpperCase() || "NA",
        orderId: data.order_item?.order?.order_id || "NA",
        order: data.product_item ? "Online Product Sale" : 
               data.seller_service ? "Online Service Sale" : 
               "Offline Product Sale",
        created_at: data.created_at,
        productName: data.order_item?.product_item?.product?.name || 
                    data.order_item?.seller_service?.service_name || 
                    data.order_item?.offline_sale_product_datum?.product_description || 
                    "NA",
        productDescription: data.order_item?.product_item?.product?.description || 
                           data.order_item?.seller_service?.service_description || 
                           data.order_item?.offline_sale_product_datum?.product_description || 
                           "NA",
        sellerInvoiceNo: data.invoice?.invoice_no || "NA",
        order_price: parseValue(data.order_price || 0, 'float'),
        taxable_value: parseValue(data.taxable_value || 0, 'float'),
        gst_rate: parseValue(data.gst_rate || 0, 'float'),
        cgst: parseValue(data.cgst || 0, 'float'),
        cgst_percent: data.cgst_percent || 0,
        igst: parseValue(data.igst || 0, 'float'),
        igst_percent: data.igst_percent || 0,
        sgst: parseValue(data.sgst || 0, 'float'),
        sgst_percent: data.sgst_percent || 0,
        utgst: parseValue(data.utgst || 0, 'float'),
        utgst_percent: data.utgst_percent || 0,
        irn: data.irn || '',
        irn_date: data.irn_date || '',
        orderQuantity: data.order_item?.order_quantity,
        orderStatus: data.order_item?.order_status,
        order_completed_on: data.order_item?.order_completed_on,
        order_cancelled_on: data.order_item?.order_cancelled_on,
        cancel_taxable_value: data?.order_item?.order_cancelled_on 
        ? -parseValue(data.taxable_value || 0, 'float') 
        : 0,
        cancel_gst_rate: data?.order_item?.order_cancelled_on 
            ? -parseValue(data.gst_rate || 0, 'float') 
            : 0,
            cancel_cgst: data?.order_item?.order_cancelled_on 
            ? -parseValue(data.cgst || 0, 'float') 
            : 0,
            cancel_cgst_percent: data?.order_item?.order_cancelled_on 
            ? -data.cgst_percent || 0 
            : 0,
            cancel_igst: data?.order_item?.order_cancelled_on 
            ? -parseValue(data.igst || 0, 'float') 
            : 0,
            cancel_igst_percent: data?.order_item?.order_cancelled_on 
            ? -data.igst_percent || 0 
            : 0,
            cancel_sgst: data?.order_item?.order_cancelled_on 
            ? -parseValue(data.sgst || 0, 'float') 
            : 0,
            cancel_sgst_percent: data?.order_item?.order_cancelled_on 
            ? -data.sgst_percent || 0 
            : 0,
            cancel_utgst: data?.order_item?.order_cancelled_on 
            ? -parseValue(data.utgst || 0, 'float') 
            : 0,
            cancel_utgst_percent: data?.order_item?.order_cancelled_on 
            ? -data.utgst_percent || 0 
            : 0,

    }));
    
    const handleExportCSV = () => {
        exportToCSV(data, 'logistics orders.csv');
    }
    
    const handleExportExcel = () => {
        exportToExcel(data, 'logistics orders.xlsx');
    }

    const handleExportPDF = () => {
        exportToPDF(data, 'logistics orders.pdf');
    }

    const columns = [
    {
        accessor: 'order_type',
        header: 'Order Type',
        render: (row) => row?.type?.toUpperCase() ?? 'NA'
    },
    {
        accessor: 'order_item.order.order_id',
        header: 'Order ID',
        render: (row) => row?.order_item?.order?.order_id ?? 'NA'
    },
    {
        accessor: 'order',
        header: 'Order',
        render: (row) =>
        row?.order_item?.product_id
            ? 'Online Product Sale'
            : row?.order_item?.service_id
            ? 'Online Service Sale'
            : 'Offline Product Sale'
    },
    { accessor: 'created_at', header: 'Order Date' },
    {
        accessor: 'productName',
        header: 'Product Name',
        render: (row) =>
        row.order_item?.product_item?.product?.name ??
        row.order_item?.seller_service?.service_name ??
        row.order_item?.offline_sale_product_datum?.product_description ??
        'NA'
    },
    {
        accessor: 'productDescription',
        header: 'Product Description',
        render: (row) =>
        row.order_item?.product_item?.product?.description ??
        row.order_item?.seller_service?.service_description ??
        row.order_item?.offline_sale_product_datum?.product_description ??
        'NA'
    },
    {
        accessor: 'sellerInvoiceNo',
        header: 'Seller Invoice No',
        render: (row) => row?.invoice?.invoice_no ?? 'NA'
    },
    {
        accessor: 'order_price',
        header: 'Order Price',
        render: (row) => parseValue(row.order_price || 0, 'float')
    },
    {
        accessor: 'taxable_value',
        header: 'Taxable Value',
        render: (row) => parseValue(row.taxable_value || 0, 'float')
    },
    {
        accessor: 'gst_rate',
        header: 'GST Rate',
        render: (row) => parseValue(row.gst_rate || 0, 'float')
    },
    {
        accessor: 'cgst',
        header: 'CGST Amount',
        render: (row) => parseValue(row.cgst || 0, 'float')
    },
    {
        accessor: 'cgst_percent',
        header: 'CGST Rate',
        render: (row) => row.cgst_percent || 0
    },
    {
        accessor: 'igst',
        header: 'IGST Amount',
        render: (row) => parseValue(row.igst || 0, 'float')
    },
    {
        accessor: 'igst_percent',
        header: 'IGST Rate',
        render: (row) => row.igst_percent || 0
    },
    {
        accessor: 'sgst',
        header: 'SGST Amount',
        render: (row) => parseValue(row.sgst || 0, 'float')
    },
    {
        accessor: 'sgst_percent',
        header: 'SGST Rate',
        render: (row) => row.sgst_percent || 0
    },
    {
        accessor: 'utgst',
        header: 'UTGST Amount',
        render: (row) => parseValue(row.utigst || 0, 'float')
    },
    {
        accessor: 'utgst_percent',
        header: 'UTGST Rate',
        render: (row) => row.utigst_percent || 0
    },
    { accessor: 'irn', header: 'IRN' },
    { accessor: 'irn_date', header: 'IRN Date' },
    {
        accessor: 'order_item.order_quantity',
        header: 'Order Quantity',
        render: (row) => row?.order_item?.order_quantity
    },
    {
        accessor: 'order_item.order_status',
        header: 'Order Status',
        render: (row) => row?.order_item?.order_status ?? 'NA'
    },
    {
        accessor: 'order_images',
        header: 'View Order Images',
        render: (row) => (
        <button
            type="button"
            className="form-control btn btn-info"
            onClick={() => showOrderImages(row.order_item.id)}
        >
            View Order Images
        </button>
        )
    },
    {
        accessor: 'order_item.order_completed_on',
        header: 'Order Completed On'
    },
    {
        accessor: 'order_item.order_cancelled_on',
        header: 'Order Cancelled On'
    },
    {
        accessor: 'cancel_order_price',
        header: 'Cancel Order Price',
        render: (row) =>
        row?.order_item?.order_status === 'process_amount_to_wallet'
            ? -parseValue(row.order_price || 0, 'float')
            : 0
    },
    {
        accessor: 'cancel_taxable_value',
        header: 'Cancel Taxable Value',
        render: (row) =>
        row?.order_item?.order_status === 'process_amount_to_wallet'
            ? -parseValue(row.taxable_value || 0, 'float')
            : 0
    },
    {
        accessor: 'cancel_gst_rate',
        header: 'Cancel GST Rate',
        render: (row) =>
        row?.order_item?.order_status === 'process_amount_to_wallet'
            ? -parseValue(row.gst_rate || 0, 'float')
            : 0
    },
    {
        accessor: 'cancel_cgst',
        header: 'Cancel CGST Amount',
        render: (row) =>
        row?.order_item?.order_status === 'process_amount_to_wallet'
            ? -parseValue(row.cgst || 0, 'float')
            : 0
    },
    {
        accessor: 'cancel_cgst_percent',
        header: 'Cancel CGST Rate',
        render: (row) =>
        row?.order_item?.order_status === 'process_amount_to_wallet'
            ? -(row.cgst_percent || 0)
            : 0
    },
    {
        accessor: 'cancel_igst',
        header: 'Cancel IGST Amount',
        render: (row) =>
        row?.order_item?.order_status === 'process_amount_to_wallet'
            ? -parseValue(row.igst || 0, 'float')
            : 0
    },
    {
        accessor: 'cancel_igst_percent',
        header: 'Cancel IGST Rate',
        render: (row) =>
        row?.order_item?.order_status === 'process_amount_to_wallet'
            ? -(row.igst_percent || 0)
            : 0
    },
    {
        accessor: 'cancel_sgst',
        header: 'Cancel SGST Amount',
        render: (row) =>
        row?.order_item?.order_status === 'process_amount_to_wallet'
            ? -parseValue(row.sgst || 0, 'float')
            : 0
    },
    {
        accessor: 'cancel_sgst_percent',
        header: 'Cancel SGST Rate',
        render: (row) =>
        row?.order_item?.order_status === 'process_amount_to_wallet'
            ? -(row.sgst_percent || 0)
            : 0
    },
    {
        accessor: 'cancel_utgst',
        header: 'Cancel UTGST Amount',
        render: (row) =>
        row?.order_item?.order_status === 'process_amount_to_wallet'
            ? -parseValue(row.utigst || 0, 'float')
            : 0
    },
    {
        accessor: 'cancel_utgst_percent',
        header: 'Cancel UTGST Rate',
        render: (row) =>
        row?.order_item?.order_status === 'process_amount_to_wallet'
            ? -(row.utigst_percent || 0)
            : 0
    },
    {
        accessor: 'delivery_user',
        header: 'Assign Delivery Person',
        render: (row) => {
        const id = row.order_item?.deliver_id || row.order_item?.return_deliver_id || row.order_item?.replace_deliver_id;
        const user = deliveryUsers.find((u) => u.id === id);
        return user ? `${user.first_name} ${user.last_name}` : 'NA';
        }
    },
    {
        accessor: 'generate_invoice',
        header: 'Generate Invoice',
        render: (row) => (
        <button
            className="btn btn-outline-success btn-sm usercardbtn1"
            onClick={() => generateInvoice(row.seller_id, row.order_id, ['logistics'])}
        >
            Logistics Invoice
        </button>
        )
    },
    {
        accessor: 'generate_cancel_invoice',
        header: 'Generate Cancel Invoice',
        render: (row) =>
        row.type === 'cancel' && (
            <button
            className="btn btn-outline-success btn-sm usercardbtn1"
            onClick={() =>
                generateReturnReplaceCancelInvoice(row.order_item_id, [row.seller_id], ['cancel_order_logistics'], 'Cancel')
            }
            >
            Cancel Logistics Invoice
            </button>
        )
    },
    {
        accessor: 'generate_return_invoice',
        header: 'Generate Return Invoice',
        render: (row) =>
        row.type === 'return' && (
            <button
            className="btn btn-outline-success btn-sm usercardbtn1"
            onClick={() =>
                generateReturnReplaceCancelInvoice(
                row.order_item_id,
                [row.order_item.seller_id],
                ['return_order_logistics'],
                'Return'
                )
            }
            >
            Return Logistics Invoice
            </button>
        )
    },
    {
        accessor: 'generate_replace_invoice',
        header: 'Generate Replace Invoice',
        render: (row) =>
        row.type === 'replace' && (
            <button
            className="btn btn-outline-success btn-sm usercardbtn1"
            onClick={() =>
                generateReturnReplaceCancelInvoice(
                row.order_item_id,
                [row.order_item.seller_id],
                ['replace_order_logistics'],
                'Replace'
                )
            }
            >
            Replace Logistics Invoice
            </button>
        )
    },
    {
        accessor: 'commission_invoice',
        header: 'Commission Invoice',
        render: (row) =>
        row.comm_invoice_no ? (
            <button className="btn btn-outline-success btn-sm" onClick={() => generateCommissionInvoice(row.id)}>
            Generate Invoice
            </button>
        ) : (
            'Invoice Yet To Be Generated'
        )
    }
    ];

    return (
        <>
            <div className="row">
                <div className='col-md-6'>
                    <h3>Logistics Orders</h3>
                </div>
                <div className='col-md-6'>
                    <button className='btn button-product' onClick={handleExportCSV}>Export to CSV</button>
                    <button className='btn button-product' onClick={handleExportExcel}>Export to Excel</button>
                    <button className='btn button-product' onClick={handleExportPDF}>Export to PDF</button>
                </div>
            </div>
            <Form className='row ml-2'>
                <FormGroup className='col-md-4 row'>
                    <Label className="col-md-2 col-form-label" for="Date-from">From:</Label>
                    <input type='date' defaultValue={location.state.startDate.length > 0 ? location.state.startDate : moment().startOf('month').format('YYYY-MM-DD')} onChange={() => getOrders()} className="form-control col-md-5" id="Date-from" name="Date-from"></input>
                </FormGroup>
                <FormGroup className='col-md-4 row'>
                    <Label className=" col-md-2 col-form-label" for="Date-to">To:</Label>
                    <input type='date' defaultValue={location.state.endDate.length > 0 ? location.state.endDate : moment().endOf('month').format('YYYY-MM-DD')} onChange={() => getOrders()} className="form-control col-md-5" id="Date-to" name="Date-to"></input>
                </FormGroup>
            </Form>
            <div className='row'>
                <div className='col-md-12'>
                    <div className="ag-theme-quartz" style={{ height: 600, width: '100%' }}>
                        <Table
                            columns={columns}
                            data={orders}
                            totalRecords={totalRecords}
                            pageSize={10}
                            onPageChange = {getOrders}
                        />
                    </div>
                </div>
            </div>

            <Modal isOpen={showOrderImagesModal} toggle={() => setShowOrderImagesModal(!showOrderImagesModal)} size="lg">
                <ModalHeader toggle={() => setShowOrderImagesModal(!showOrderImagesModal)}>Order Images</ModalHeader>
                <ModalBody>
                    {
                        orderImagesData && orderImagesData.length > 0 ?
                        <table>
                            <thead>
                                <th>Photo</th>
                                <th>Uploaded By</th>
                                <th>Type</th>
                                <th>Upload Date Time</th>
                            </thead>
                            <tbody>
                            {
                                orderImagesData.map((imageData) => {
                                    return (
                                    <>
                                        <tr>
                                            <td><img src={envConfig.api_url + imageData.photo} style={{ width: '100px', height: '100px', objectFit: 'cover' }} /></td>
                                            <td>{imageData.uploaded_via}</td>
                                            <td>{imageData.type}</td>
                                            <td>{imageData.created_at}</td>
                                        </tr>
                                    </>
                                    )
                                })
                            }
                            </tbody>
                        </table>
                        :
                        <h4>No Order Images</h4>
                    }
                </ModalBody>
            </Modal>
        </>
    )
}